import { useState } from 'react';
import { FGButton, FGModal, FGSelect, FGTypography } from '@fg/design-system';
import { CHART_EXPORT_FILE_TYPES } from '../../constants';
import GQPopupStorage from 'components/GQPopup/GQPopupStorage';

type Props = {
    onExportButtonClicked: (selectedType: CHART_EXPORT_FILE_TYPES) => void;
};

export const EXPORT_CHART_MODAL_KEY = 'export-chart-popup';

const EXPORT_TYPES_TO_LABELS = {
    [CHART_EXPORT_FILE_TYPES.PNG]: 'PNG',
    [CHART_EXPORT_FILE_TYPES.CSV]: 'CSV',
    [CHART_EXPORT_FILE_TYPES.CSV_AND_PNG]: 'CSV & PNG',
};

const selectCssStyles = {
    control: (baseStyles, state) => ({
        ...baseStyles,
        cursor: 'pointer',
        width: '200px',
        
    }),
    menu: (baseStyles, state) => ({
        ...baseStyles,
        border: '0px',
    }),
    input: (baseStyles, state) => ({
        ...baseStyles,
        cursor: 'pointer',
    }),
    option: (baseStyles, state) => ({
        ...baseStyles,
        cursor: 'pointer',
    }),
};

['valueContainer', 'singleValue', 'placeholder'].forEach(cssClassName => {
    selectCssStyles[cssClassName] = (baseStyles, state) => ({
        cursor: 'pointer',
        ...baseStyles,
    });
});

const ChartExportModal = ({ onExportButtonClicked }: Props) => {
    const [selectedType, setSelectedType] = useState(
        CHART_EXPORT_FILE_TYPES.CSV
    );

    const onSelectType = e => {
        const newType = e.value;
        if (newType !== selectedType) {
            setSelectedType(newType);
        }
    };

    const closePopup = () => {
        GQPopupStorage.addData(EXPORT_CHART_MODAL_KEY, null);
    };

    return (
        <FGModal
            isOpen
            className="export-chart-popup"
            header="Export chart data"
            onRequestClose={closePopup}
            footerActionComponents={[
                <FGButton variant="ghost" onClick={closePopup} data-testid="chart-export-cancel">
                    <FGTypography tag="label" variant="body3-short">
                        Cancel
                    </FGTypography>
                </FGButton>,
                <FGButton
                    data-testid="chart-export-confirm"
                    variant="primary"
                    className="export-chart-button"
                    disabled={!selectedType}
                    onClick={() => onExportButtonClicked(selectedType)}>
                    <FGTypography
                        tag="label"
                        variant="body3-short"
                        className="export-chart-button-text">
                        Export data
                    </FGTypography>
                </FGButton>,
            ]}>
            <FGTypography
                tag="p"
                variant="body3-short"
                cssStyle={{ marginBottom: '24px' }}>
                Download chart data for selected countries and metrics (excluding Risk Hotspots). Choose preferred format.
            </FGTypography>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}>
                <FGTypography variant="label2" tag="label" cssStyle={{ color: 'var(--fg-color-text)' }}>
                    Export format
                </FGTypography>
                <FGSelect
                    testId="chart-export-format"
                    value={{
                        value: selectedType,
                        label: EXPORT_TYPES_TO_LABELS[selectedType],
                    }}
                    styles={selectCssStyles}
                    onChange={onSelectType}
                    isClearable={false}
                    isSearchable={false}
                    options={Object.values(CHART_EXPORT_FILE_TYPES).map(
                        (type: string) => ({
                            value: type,
                            label: EXPORT_TYPES_TO_LABELS[type],
                        })
                    )}></FGSelect>
            </div>
        </FGModal>
    );
};
export default ChartExportModal;
